import { Navigate, Outlet } from "react-router-dom";

const PublicLayout = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  if (userData && typeof userData == "object" && Object.keys(userData).length) {
    return <Navigate to="/dashboard" replace={true} />;
  }

  return <Outlet />;
};

export default PublicLayout;
